import { useState, useEffect } from "react";
import LoadingOverlay from "react-loading-overlay";
import { useSelector } from "react-redux";
const LoginRedirect = () => {
    const data = useSelector((state) => state.loginRedirectReducer.loginRedirectDetails);
    console.log(data,"ff");
    useEffect(() => {
        if(data){
        localStorage.setItem("AuthData", JSON.stringify(data));
        localStorage.setItem("AuthToken", data.token);
        localStorage.setItem("userDetails", JSON.stringify(data.data));
        localStorage.setItem(
          "clientDetails",
          JSON.stringify(data.clientDetails),
        );
        localStorage.setItem(
          "serviceAccess",
          JSON.stringify(data.serviceAccess),
        );
        localStorage.setItem("GPTtoken", data.GPTtoken);
        // window.open("/", "_self");
    }
    },[data])
};

export default LoginRedirect;